/** Константи та опис полів форми офера. */

export const API_FIELD_MAP = {
  name: ["name"],
  for_who: ["forWho", "for_who"],
  duration: ["duration"],
  procedure_description: ["procedureDescription", "procedure_description"],
  accommodation: ["accommodation"],
  transport: ["transport"],
  other_services: ["otherServices", "other_services"],
  post_operation_care: ["postOperationCare", "post_operationCare", "post_operation_care"],
  implant: ["implant"],
  promo_description: ["promo_description"]
};

export const SERVICE_DISPLAY_FIELD_TYPES = {
  accommodation: "accommodation",
  transport: "transfer",
  other_services: "common",
  implant: "implant"
};

export const LEVEL_OPTIONS = ["1", "2", "3", "4", "5"];

export const SERVICE_GROUP_LABELS = {
  medical: "Medical",
  common: "Common",
  implant: "Implant",
  transfer: "Transfer",
  accommodation: "Accommodation"
};

export const TRANSLATABLE_FIELDS = [
  {
    key: "name",
    input: "base",
    label: "Name",
    requiredEn: true,
    placeholder: (lang) => `Offer name in ${lang.toUpperCase()}`
  },
  {
    key: "for_who",
    input: "textarea",
    rows: 6,
    label: "For Who",
    placeholder: (lang) => `For Who in ${lang.toUpperCase()}`
  },
  {
    key: "duration",
    input: "base",
    label: "Duration",
    placeholder: (lang) => `Duration in ${lang.toUpperCase()}`
  },
  {
    key: "procedure_description",
    input: "textarea",
    rows: 4,
    label: "Procedure Description",
    placeholder: (lang) => `Procedure Description in ${lang.toUpperCase()}`
  },
  {
    key: "accommodation",
    input: "textarea",
    rows: 4,
    label: "Accommodation",
    placeholder: (lang) => `Accommodation in ${lang.toUpperCase()}`
  },
  {
    key: "transport",
    input: "textarea",
    rows: 4,
    label: "Transport",
    placeholder: (lang) => `Transport in ${lang.toUpperCase()}`
  },
  {
    key: "other_services",
    input: "textarea",
    rows: 4,
    label: "Other Services",
    placeholder: (lang) => `Other services in ${lang.toUpperCase()}`
  },
  {
    key: "post_operation_care",
    input: "textarea",
    rows: 4,
    label: "Post Operation Care",
    placeholder: (lang) => `Post Operation Care in ${lang.toUpperCase()}`
  },
  {
    key: "implant",
    input: "textarea",
    rows: 4,
    label: "Implant",
    placeholder: (lang) => `Implant in ${lang.toUpperCase()}`
  },
  {
    key: "promo_description",
    input: "textarea",
    rows: 4,
    label: "Promo Description",
    placeholder: (lang) => `Promo Description in ${lang.toUpperCase()}`
  }
];
